import { MOBILE_VIEWPORT_MEDIA_QUERY } from "../../utils/viewportBreakpoints";

/** Inline surface reset for main-menu panel toggles (matches pre–17d96f7 markup). */
export const MAIN_MENU_CONTROL_SURFACE_STYLE = Object.freeze({
  backgroundColor: "transparent",
  outline: "none",
});

export const PANEL_SQUARE_TOGGLE_OUTLINE_STYLE = Object.freeze({
  borderColor: "var(--panel-border)",
});

/** Matches index.css: keeps ::before hover overlay visible for open panels / selected tiles. */
export const MAIN_MENU_PANEL_TOGGLE_OPEN_CLASS = "main-menu-panel-toggle-open";

/** Scoped hook for index.css — kills shared menu gray hover on main-menu panel rows only. */
export const MAIN_MENU_HOVER_SURFACE_CLASS = "main-menu-hover-surface";
export const MAIN_MENU_DRAGGABLE_PANEL_TOGGLE_CLASS = "main-menu-draggable-panel-toggle";
export const PANEL_SQUARE_TOGGLE_BUTTON_CLASS = `${MAIN_MENU_HOVER_SURFACE_CLASS} ${MAIN_MENU_DRAGGABLE_PANEL_TOGGLE_CLASS} relative flex min-w-0 flex-col items-center justify-center gap-1 rounded-md border bg-transparent px-2 py-1.5 text-center text-gray-200 transition-colors duration-[400ms] ease-out focus:outline-none`;
export const PANEL_SQUARE_TOGGLE_SIZE_CLASS = "h-16 w-full";
export const PANEL_SQUARE_TOGGLE_ICON_SLOT_CLASS =
  "flex h-6 w-6 shrink-0 items-center justify-center";
export const PANEL_SQUARE_TOGGLE_ICON_CLASS = "h-5 w-5";
export const PANEL_SQUARE_TOGGLE_LABEL_CLASS =
  "max-w-full whitespace-normal break-words text-xs font-medium leading-tight";
export const ENVIRONMENT_ZIP_HELP_TEXT =
  "Save and reopen your full Critter project, including assets.";
export const ENVIRONMENT_EXPORT_ADVANCED_HELP_TEXT =
  "Downloads a smaller .critterrefs project that references mesh assets instead of embedding them. Use this when the meshes are already available where the project will be reopened, or when you plan to upload the meshes separately.";
export const DEPLOYMENT_BUNDLE_HELP_TEXT =
  "Exports URDF, MJCF, assets, and deployment metadata for ROS2/hardware integration.";
export const DEPLOYMENT_URDF_DIFFERENCE_HELP_TEXT =
  "URDF is mainly a robot description format for ROS tools. It does not represent every MuJoCo simulation feature, so the bundle keeps the full MJCF model and metadata alongside the URDF.";
export const MJCF_EXPORT_DIFFERENCE_HELP_TEXT =
  "MJCF is the MuJoCo simulation model. It may not preserve every Critter editor, training, or workflow feature; use Save Project when you want to save and reopen the full Critter setup.";
export const EXPORT_REVIEW_ACTION_BUTTON_CLASS =
  "w-full gap-2 border border-gray-600 bg-transparent text-gray-100 hover:border-gray-500 hover:bg-gray-700";
export const EXPORT_REVIEW_LABELS = {
  ready: "Ready",
  ready_with_warnings: "Ready with warnings",
  needs_review: "Needs review",
  blocked: "Needs attention",
};
export const MOBILE_PANEL_MEDIA_QUERY = MOBILE_VIEWPORT_MEDIA_QUERY;
/** Expanded main menu width cap — mobile uses a narrower strip so more of the canvas stays visible. */
export const MAIN_MENU_PANEL_MAX_WIDTH_MOBILE = "12rem";
export const MAIN_MENU_PANEL_MAX_WIDTH_DEFAULT = "16rem";
export const MAIN_MENU_DROPDOWN_TRIGGER_CLASS = `${MAIN_MENU_HOVER_SURFACE_CLASS} h-8 w-8 shrink-0 flex items-center justify-center rounded-md bg-transparent border-0 text-gray-200 transition-colors duration-[400ms] ease-out cursor-pointer outline-none focus:outline-none`;
export const MAIN_MENU_DROPDOWN_ICON_CLASS = "h-3.5 w-3.5 shrink-0 text-gray-200";
